import Snappy from '../libs/snappy/snappy';
import OptaService from '../libs/optaService/optaService';
import EcalService from '../libs/eCalService/eCalService';
import Twitter from '../libs/social/twitter';
import objectFitImages from 'object-fit-images';

objectFitImages(document.querySelectorAll('img:not(.lazyload)'));

import '../components/resizement/scripts/resize';
import '../.modernizrrc';
import '../styles/main.scss';

require('./bootstrapComponents');
require('./globalConfigs');
require('./pollyfills');
require('./picturefill');
require('../libs/validation/serverValidation');
require('../components/lazyimages/scripts/lazyimages');
require('../components/cfa-nav/scripts/cfa-nav');
require('../components/video/scripts/video');
require('../components/responsive-video/scripts/responsive-video');
require('../components/navigation/scripts/navigation');
require('../components/subNavigation/scripts/subNavigation');
require('../components/footer/scripts/footer');
require('../components/modal/scripts/modal');
require('../components/carousel/scripts/carousel');
require('../components/rowStrip/scripts/rowStrip');
require('../components/rowHeading/scripts/rowHeading');
require('../components/inputField/scripts/inputField');
require('../components/textarea/scripts/textarea');
require('../components/contentPromo/scripts/contentPromo');
require('../components/contentPromoHero/scripts/contentPromoHero');
require('../components/contentPromoVideo/scripts/contentPromoVideo');
require('../components/signpostContentPromo/scripts/signpostContentPromo');
require('../components/signpostContentPromoHero/scripts/signpostContentPromoHero');
require('../components/signpostContentPromoLinkList/scripts/signpostContentPromoLinkList');
require('../components/signpostContentPromoQuote/scripts/signpostContentPromoQuote');
require('../components/tickets/scripts/tickets');
require('../components/findFootball/scripts/findFootball');
require('../components/findCourse/scripts/findCourse');
require('../components/breadcrumbs/scripts/breadcrumbs');
require('../components/poll/scripts/poll');
require('../components/backToTop/scripts/backToTop');
require('../components/latestScoresFixtures/scripts/latestScoresFixtures');
require('../components/liveScores/scripts/liveScores');
require('../components/cookie/scripts/cookie');
require('../components/faqs/scripts/faqs');
require('../components/contactForm/scripts/contactForm');
require('../components/topbar/scripts/topbar');
require('../components/pageMedia/scripts/pageMedia');
require('../components/gallery/scripts/gallery');
require('../components/socialShare/scripts/socialShare');
require('../components/relatedContent/scripts/relatedContent');
require('../components/campaign/scripts/campaign');
require('../components/articleTable/scripts/articleTable');
require('../components/quote/scripts/quote');
require('../components/usefulResources/scripts/usefulResources');
require('../components/communityAwards/scripts/nominationForm');
require('../components/filters/scripts/filters');
require('../components/comparisonTool/scripts/comparisonTool');
require('../components/suspensions/scripts/suspensions');

require('../components/cw-footer/scripts/footer');
require('../components/cw-enquiryForm/scripts/enquiryForm');
require('../components/cw-newsletterForm/scripts/newsletterForm');
require('../components/video-seats/scripts/video');
require('../components/accordion/scripts/accordion');
require('../components/dropdown/scripts/dropdown');
require('../components/content-loader/scripts/contentLoader');
require('../components/related-documents/scripts/related-documents');
require('../components/scrollto/scripts/scrollto');
require('../components/media-gallery/scripts/media-gallery');
require('../components/tabs/scripts/tabs');
require('../components/disciplinary-search/scripts/disciplinary-search');
require('../components/tracking/scripts/tracking');
require('../components/cfa-search-results/scripts/cfa-search-results');
require('../components/cfa-search-results/scripts/cfa-clear-field');

Snappy.init();
OptaService.init();
EcalService.init();
Twitter.init();

const files = require.context("../assets/svg", true, /^\.\/.*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./scripts/main.js